import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AddOnService } from 'src/app/services/add-on.service';
import { PartnerService } from 'src/app/services/partner.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  standalone: false,
  selector: 'app-add-ons-add',
  templateUrl: './add-ons-add.component.html',
})
export class AddOnsAddComponent implements OnInit {
  form: any = {
    partner_id: null,
    product_id: null,
    discount_type: 1,
    discount_value: '',
    status: 1,
  };
  partners: any[] = [];
  partnersLoaded = false;
  products: any[] = [];
  productsLoaded = false;
  validationTriggered = false;

  constructor(
    private toaster: ToastrService,
    private router: Router,
    private addOnService: AddOnService,
    private partnerService: PartnerService,
    private productService: ProductService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.partnerService.list().subscribe({
      next: (partners) => {
        this.partners = [...partners];
        this.partnersLoaded = true;
        if (this.form.partner_id == null && this.partners.length === 1) {
          this.form.partner_id = this.partners[0].partner_id;
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.partners = [];
        this.partnersLoaded = true;
        this.toaster.error('Failed to load partners.');
        this.cdr.detectChanges();
      },
    });

    this.productService.list({ page: 1, per_page: 100 }).subscribe({
      next: (result) => {
        this.products = [...(result?.data?.products ?? [])];
        this.productsLoaded = true;
        if (this.form.product_id == null && this.products.length === 1) {
          this.form.product_id = this.products[0].id;
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.products = [];
        this.productsLoaded = true;
        this.toaster.error('Failed to load products.');
        this.cdr.detectChanges();
      },
    });
  }

  submit(): void {
    this.validationTriggered = true;
    if (
      !this.form.partner_id ||
      !this.form.product_id ||
      this.form.discount_value === '' ||
      this.form.discount_value === null
    ) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      partner_id: this.form.partner_id,
      product_id: Number(this.form.product_id),
      discount_type: Number(this.form.discount_type),
      discount_value: Number(this.form.discount_value),
      status: Number(this.form.status),
    };

    this.addOnService.create(payload).subscribe({
      next: (result) => {
        this.toaster.success('Add-on added.');
        this.router.navigate(['/ecomm/add-ons', result.data.id]);
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to add add-on.');
      },
    });
  }
}
